// extracted by mini-css-extract-plugin
export default {"root":"ItemStatus_root__zAwmV","done":"ItemStatus_done__8WnyN","todo":"ItemStatus_todo__ks1qk"};